"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SupportButton = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styles = require("@material-ui/core/styles");
var _core = require("@material-ui/core");
var _CloseRounded = _interopRequireDefault(require("@material-ui/icons/CloseRounded"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var DefaultSupportIcon = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDQiIGhlaWdodD0iNDQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PG1hc2sgaWQ9IkRlZmF1bHRTdXBwb3J0SWNvbi1tYXNrMCIgc3R5bGU9Im1hc2stdHlwZTphbHBoYSIgbWFza1VuaXRzPSJ1c2VyU3BhY2VPblVzZSIgeD0iMyIgeT0iMyIgd2lkdGg9IjM4IiBoZWlnaHQ9IjM4Ij48cGF0aCBkPSJNMzYuNjY3IDMuNjY3SDcuMzMzYTMuNjc3IDMuNjc3IDAgMDAtMy42NjYgMy42NjZ2MzNMMTEgMzNoMjUuNjY3YTMuNjc3IDMuNjc3IDAgMDAzLjY2Ni0zLjY2N3YtMjJhMy42NzcgMy42NzcgMCAwMC0zLjY2Ni0zLjY2N3oiIGZpbGw9IiNmZmYiLz48L21hc2s+PGcgbWFzaz0idXJsKCNEZWZhdWx0U3VwcG9ydEljb24tbWFzazApIj48cGF0aCBmaWxsPSIjZmZmIiBkPSJNMCAwaDQ0djQ0SDB6Ii8+PC9nPjxwYXRoIGQ9Ik0yMC41NTUgMjEuODJjMC0uODY2LjEwNy0xLjU1Ni4zMjItMi4wNy4yMTUtLjUxNC42MzgtMS4wNzggMS4yNy0xLjY5LjYzOC0uNjE4IDEuMDQxLTEuMDU3IDEuMjEtMS4zMTguMjYtLjM5Ny4zOTEtLjgyNy4zOTEtMS4yODkgMC0uNjEyLS4xNTMtMS4wNzctLjQ1OS0xLjM5Ni0uMy0uMzI2LS43NDItLjQ4OS0xLjMyOC0uNDg5LS41NiAwLTEuMDEyLjE2LTEuMzU3LjQ3OS0uMzM5LjMxMi0uNTA4LjczOS0uNTA4IDEuMjhoLTIuMzczYy4wMTMtMS4xNTMuNDAzLTIuMDY1IDEuMTcyLTIuNzM1Ljc3NC0uNjcgMS43OTYtMS4wMDYgMy4wNjYtMS4wMDYgMS4zMDkgMCAyLjMyNy4zMzIgMy4wNTcuOTk2LjczNS42NjQgMS4xMDMgMS41OTIgMS4xMDMgMi43ODMgMCAxLjA2MS0uNDk1IDIuMTA2LTEuNDg0IDMuMTM1bC0xLjIwMSAxLjE4MmMtLjQzLjQ4OC0uNjUxIDEuMi0uNjY1IDIuMTM4aC0yLjIxNnptLS4xNjYgMy4wMzdjMC0uMzg0LjEyLS42OTMuMzYxLS45MjcuMjQtLjI0MS41NjYtLjM2Mi45NzctLjM2Mi40MTYgMCAuNzQ1LjEyNC45ODYuMzcxLjI0LjI0MS4zNjEuNTQ3LjM2MS45MTggMCAuMzU4LS4xMTcuNjU4LS4zNTEuODk5LS4yMzUuMjQtLjU2Ny4zNjEtLjk5Ni4zNjEtLjQzIDAtLjc2Mi0uMTItLjk5Ny0uMzYxYTEuMjU3IDEuMjU3IDAgMDEtLjM0MS0uODk5eiIgZmlsbD0iIzIxMjUyOSIvPjwvc3ZnPg==";
const SupportButton = _ref => {
  let {
    textButton,
    color,
    title,
    children,
    clearChildrenStates,
    supportIcon,
    classCustom
  } = _ref;
  const useStyles = (0, _styles.makeStyles)(theme => ({
    button: {
      borderRadius: '8px 8px 8px 8px',
      height: 62,
      width: 62,
      top: '80vh',
      right: 0,
      position: 'fixed',
      [theme.breakpoints.down(600)]: {
        height: 42,
        width: 42
      }
    },
    buttonHover: {
      right: 250,
      boxShadow: 'none'
    },
    textButton: {
      width: 250,
      boxShadow: 'none',
      textTransform: 'none'
    },
    icon: {
      margin: '15px 10px 10px 10px',
      '& svg': {
        width: '44px',
        height: '44px'
      },
      '& img': {
        width: '44px',
        height: '44px'
      },
      [theme.breakpoints.down(600)]: {
        '& svg': {
          width: '30px',
          height: '30px'
        },
        '& img': {
          width: '30px',
          height: '30px'
        }
      }
    },
    card: {
      overflow: 'auto',
      right: 0,
      width: 312,
      maxHeight: '70vh',
      bottom: '20vh',
      position: 'fixed',
      [theme.breakpoints.down(600)]: {
        width: '100vw',
        minHeight: '100vh',
        top: 0
      }
    },
    cardHeader: {
      zIndex: 2,
      position: 'fixed',
      width: 312,
      borderRadius: '8px 8px 0px 0px',
      backgroundColor: theme.palette.background.paper,
      [theme.breakpoints.down(600)]: {
        width: '100vw'
      }
    },
    cardTitle: {
      right: 0,
      left: 0,
      padding: 0,
      fontWeight: 500,
      color: theme.palette.text.primary
    },
    cardContent: {
      zIndex: -1,
      marginTop: 62,
      paddingRight: 16,
      paddingLeft: 16
    },
    closeButton: {
      position: 'absolute',
      right: 0
    }
  }));
  /**
   * Componente primário de interação com o usuário
   */
  const classes = useStyles();
  const [inHover, setHover] = _react.default.useState(false);
  const [anchorEl, setAnchorEl] = _react.default.useState(null);
  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
    setHover(false);
    clearChildrenStates();
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    onMouseEnter: () => setHover(true),
    onMouseLeave: () => setHover(false)
  }, inHover ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_core.Fab, {
    "aria-describedby": "simple-popover",
    color: color,
    onClick: handleClick,
    className: `${classes.button} ${classes.buttonHover} ${classCustom}`
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.icon
  }, supportIcon)), /*#__PURE__*/_react.default.createElement(_core.Fab, {
    "aria-describedby": "simple-popover",
    color: color,
    onClick: handleClick,
    className: `${classes.button} ${classes.textButton} ${classCustom}`
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "subtitle1",
    className: classes.text
  }, textButton))) : /*#__PURE__*/_react.default.createElement(_core.Fab, {
    "aria-describedby": "simple-popover",
    color: color,
    onClick: handleClick,
    className: `${classes.button} ${classCustom}`
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.icon
  }, supportIcon)), /*#__PURE__*/_react.default.createElement(_core.Popover, {
    id: "simple-popover",
    open: Boolean(anchorEl),
    className: classCustom,
    anchorEl: anchorEl,
    onClose: handleClose,
    elevation: 0,
    anchorOrigin: {
      vertical: 'top',
      horizontal: 'right'
    },
    transformOrigin: {
      vertical: 'bottom',
      horizontal: 'right'
    }
  }, /*#__PURE__*/_react.default.createElement(_core.Card, {
    className: classes.card
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.cardHeader
  }, /*#__PURE__*/_react.default.createElement(_core.CardHeader, {
    action: /*#__PURE__*/_react.default.createElement(_core.IconButton, {
      className: classes.closeButton,
      onClick: handleClose
    }, /*#__PURE__*/_react.default.createElement(_CloseRounded.default, null)),
    title: /*#__PURE__*/_react.default.createElement(_core.Typography, {
      variant: "h6",
      className: classes.cardTitle
    }, title)
  }), /*#__PURE__*/_react.default.createElement(_core.Divider, null)), /*#__PURE__*/_react.default.createElement(_core.CardContent, {
    className: classes.cardContent
  }, children))));
};
exports.SupportButton = SupportButton;
SupportButton.propTypes = {
  /**
   * Texto do botão
   */
  textButton: _propTypes.default.string,
  /**
   * Cor do botão
   */
  color: _propTypes.default.oneOf(['primary', 'secondary']),
  /**
   * Título do Card a ser exibido
   */
  title: _propTypes.default.string,
  /**
   * Conteúdo que será exibido no Card
   */
  children: _propTypes.default.node.isRequired,
  /**
   * Função para limpar os estados do Children quando fechar o componente
   */
  clearChildrenStates: _propTypes.default.func,
  /**
   * Ícone exibido no botão principal'
   */
  supportIcon: _propTypes.default.node,
  /**
   * CSS customizado para o elemento
   */
  classCustom: _propTypes.default.node
};
SupportButton.defaultProps = {
  textButton: 'Dúvidas? Fale conosco!',
  color: 'primary',
  title: 'Envie sua dúvida aqui',
  clearChildrenStates: null,
  supportIcon: /*#__PURE__*/_react.default.createElement("img", {
    src: DefaultSupportIcon,
    alt: "Suporte"
  }),
  classCustom: null
};
var _default = exports.default = SupportButton;